import styled from "styled-components";


export const ContainerContato = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
        background: #f9f9f9;
       font-family: Helvetica Neue, serif;
    overflow-x: hidden;
    

`;


export const ContainerMap = styled.div`
    background: #f9f9f9;
    width: 100%;
    display: flex;
    padding: 20px;
    height: 70%;
    margin-top: 200px;
`;

export const ContainerInfo = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-around;
    background: #3C3C3C;

    width: 100%;
    height: 220px
`;

export const WrapperLogo = styled.div`
    display: flex;
    align-items: center;
    width: 25%;
`;

export const LinkContato = styled.div`
    margin: 10px;
    cursor: pointer;
    color: white;
    &:hover{
    color: rgba(255,255,255,0.62);
     transform: scale(1.1);
    }
`;